import { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router'
import callAPI from '../../../helpers/callAPI'
import Loading from '../../../templates/UI/Loading/Loading'
import queryString from 'query-string'
import { Collapse } from 'react-bootstrap'

import SearchOptions from './SearchOptions'
import SearchResults from './SearchResults'

const SearchCampaigns = ({ showSystemMessage }) => {
    document.title = 'Campaign Search'

    const [open, setOpen] = useState(true)
    const [dataLoaded, setDataLoaded] = useState()
    const [searchResults, setSearchResults] = useState([])

    const location = useLocation()
    const history = useHistory()

    let urlParams = queryString.parse(location.search)

    const [traffic, setTraffic] = useState({
        searchTraffic: !urlParams.searchTraffic ? true : urlParams.searchTraffic === 'false' ? false : true,
        emailTraffic: !urlParams.emailTraffic ? true : urlParams.emailTraffic === 'false' ? false : true,
        incentiveTraffic: !urlParams.incentiveTraffic ? true : urlParams.incentiveTraffic === 'false' ? false : true,
        contextualTraffic: !urlParams.contextualTraffic ? true : urlParams.contextualTraffic === 'false' ? false : true,
        socialTraffic: !urlParams.socialTraffic ? true : urlParams.socialTraffic === 'false' ? false : true,
        bannerTraffic: !urlParams.bannerTraffic ? true : urlParams.bannerTraffic === 'false' ? false : true,
        mobileTraffic: !urlParams.mobileTraffic ? true : urlParams.mobileTraffic === 'false' ? false : true,
        nativeTraffic: !urlParams.nativeTraffic ? true : urlParams.nativeTraffic === 'false' ? false : true,
        brandBidTraffic: !urlParams.brandBidTraffic ? true : urlParams.brandBidTraffic === 'false' ? false : true,
        couponTraffic: !urlParams.couponTraffic ? true : urlParams.couponTraffic === 'false' ? false : true,
        cashbackTraffic: !urlParams.cashbackTraffic ? true : urlParams.cashbackTraffic === 'false' ? false : true,
        bnplTraffic: !urlParams.bnplTraffic ? true : urlParams.bnplTraffic === 'false' ? false : true
    })

    const [status, setStatus] = useState(urlParams.status ? urlParams.status : '')

    const [adminId, setAdminId] = useState(urlParams.adminId ? urlParams.adminId : 0)
    const [country, setCountry] = useState(urlParams.country ? urlParams.country : '')
    const [cpaType, setCpaType] = useState(urlParams.cpaType ? urlParams.cpaType : '')
    const [htmlPostbacks, setHtmlPostbacks] = useState(urlParams.htmlPostbacks ? (urlParams.htmlPostbacks === 'true' ? true : false) : false)
    const [displayRates, setDisplayRates] = useState(urlParams.displayRates ? (urlParams.displayRates === 'true' ? true : false) : false)
    const [mobileCampaign, setMobileCampaign] = useState(urlParams.mobileCampaign ? (urlParams.mobileCampaign === 'true' ? true : false) : false)
    const [trackingPlatform, setTrackingPlatform] = useState(urlParams.trackingPlatform ? urlParams.trackingPlatform : '')
    const [currency, setCurrency] = useState(urlParams.currency ? urlParams.currency : '')
    const [flagId, setFlagId] = useState(urlParams.flagId ? urlParams.flagId : '')
    const [category, setCategory] = useState({
        categoryId: urlParams.categoryId ? urlParams.categoryId : 0,
        subCategoryId: urlParams.subCategoryId ? urlParams.subCategoryId : 0,
    })
    const [trackingType, setTrackingType] = useState(urlParams.trackingType ? urlParams.trackingType : '')
    const [campaignType, setCampaignType] = useState(urlParams.campaignType ? urlParams.campaignType : '')
    const [paymentDelay, setPaymentDelay] = useState(urlParams.paymentDelay ? urlParams.paymentDelay : '')
    const [safeSearchEnabled, setSafeSearchEnabled] = useState(urlParams.safeSearchEnabled ? urlParams.safeSearchEnabled : '')
    const [safeSearchCertified, setSafeSearchCertified] = useState(urlParams.safeSearchCertified ? urlParams.safeSearchCertified : '')
    const [prepop, setPrepop] = useState(urlParams.prepop ? urlParams.prepop : '')
    const [coupon, setCoupon] = useState(urlParams.coupon ? urlParams.coupon : '')
    const [deeplink, setDeeplink] = useState(urlParams.deeplink ? urlParams.deeplink : '')

    const buildUrl = (url) => {
        if (!traffic.searchTraffic) {
            url += `&searchTraffic=false`
        }

        if (!traffic.emailTraffic) {
            url += `&emailTraffic=false`
        }

        if (!traffic.incentiveTraffic) {
            url += `&incentiveTraffic=false`
        }

        if (!traffic.contextualTraffic) {
            url += `&contextualTraffic=false`
        }

        if (!traffic.socialTraffic) {
            url += `&socialTraffic=false`
        }

        if (!traffic.bannerTraffic) {
            url += `&bannerTraffic=false`
        }

        if (!traffic.mobileTraffic) {
            url += `&mobileTraffic=false`
        }

        if (!traffic.nativeTraffic) {
            url += `&nativeTraffic=false`
        }

        if (!traffic.brandBidTraffic) {
            url += `&brandBidTraffic=false`
        }

        if(!traffic.couponTraffic) {
            url += `&couponTraffic=false`
        }

        if(!traffic.cashbackTraffic) {
            url += `&cashbackTraffic=false`
        }

        if(!traffic.bnplTraffic) {
            url += `&bnplTraffic=false`
        }

        if (status !== '') {
            url += `&status=${status}`
        }

        if (adminId !== 0 && adminId !== '') {
            url += `&adminId=${adminId}`
        }

        if (country !== '') {
            url += `&country=${country}`
        }

        if (cpaType !== '') {
            url += `&cpaType=${cpaType}`
        }

        if (htmlPostbacks) {
            url += `&htmlPostbacks=true`
        }

        if (displayRates) {
            url += `&displayRates=true`
        }

        if (mobileCampaign) {
            url += `&mobileCampaign=true`
        }

        if (trackingPlatform !== '') {
            url += `&trackingPlatform=${trackingPlatform}`
        }

        if (currency !== '') {
            url += `&currency=${currency}`
        }

        if (flagId !== '') {
            url += `&flagId=${flagId}`
        }

        if (parseInt(category.categoryId) > 0) {
            url += `&categoryId=${category.categoryId}`
        }

        if (parseInt(category.subCategoryId) > 0) {
            url += `&subCategoryId=${category.subCategoryId}`
        }

        if (trackingType !== '') {
            url += `&trackingType=${trackingType}`
        }

        if (campaignType !== '') {
            url += `&campaignType=${campaignType}`
        }

        if (paymentDelay !== '') {
            url += `&paymentDelay=${paymentDelay}`
        }

        if (safeSearchEnabled !== '') {
            url += `&safeSearchEnabled=${safeSearchEnabled}`
        }

        if (safeSearchCertified !== '') {
            url += `&safeSearchCertified=${safeSearchCertified}`
        }

        if (prepop !== '') {
            url += `&prepop=${prepop}`
        }

        if (coupon !== '') {
            url += `&coupon=${coupon}`
        }

        if (deeplink !== '') {
            url += `&deeplink=${deeplink}`
        }

        return url
    }

    useEffect(() => {
        setDataLoaded(false)
        // Grab the settings from the URL Bar if location changes

        setTraffic({
            searchTraffic: !urlParams.searchTraffic ? (traffic.searchTraffic ? traffic.searchTraffic : false) : urlParams.searchTraffic === 'false' ? false : true,
            emailTraffic: !urlParams.emailTraffic ? (traffic.emailTraffic ? traffic.emailTraffic : false) : urlParams.emailTraffic === 'false' ? false : true,
            incentiveTraffic: !urlParams.incentiveTraffic ? (traffic.incentiveTraffic ? traffic.incentiveTraffic : false) : urlParams.incentiveTraffic === 'false' ? false : true,
            contextualTraffic: !urlParams.contextualTraffic ? (traffic.contextualTraffic ? traffic.contextualTraffic : false) : urlParams.contextualTraffic === 'false' ? false : true,
            socialTraffic: !urlParams.socialTraffic ? (traffic.socialTraffic ? traffic.socialTraffic : false) : urlParams.socialTraffic === 'false' ? false : true,
            bannerTraffic: !urlParams.bannerTraffic ? (traffic.bannerTraffic ? traffic.bannerTraffic : false) : urlParams.bannerTraffic === 'false' ? false : true,
            mobileTraffic: !urlParams.mobileTraffic ? (traffic.mobileTraffic ? traffic.mobileTraffic : false) : urlParams.mobileTraffic === 'false' ? false : true,
            nativeTraffic: !urlParams.nativeTraffic ? (traffic.nativeTraffic ? traffic.nativeTraffic : false) : urlParams.nativeTraffic === 'false' ? false : true,
            brandBidTraffic: !urlParams.brandBidTraffic ? (traffic.brandBidTraffic ? traffic.brandBidTraffic : false) : urlParams.brandBidTraffic === 'false' ? false : true,
            couponTraffic: !urlParams.couponTraffic ? (traffic.couponTraffic ? traffic.couponTraffic : false) : urlParams.couponTraffic === 'false' ? false : true,
            cashbackTraffic: !urlParams.cashbackTraffic ? (traffic.cashbackTraffic ? traffic.cashbackTraffic : false) : urlParams.cashbackTraffic === 'false' ? false : true,
            bnplTraffic: !urlParams.bnplTraffic ? (traffic.bnplTraffic ? traffic.bnplTraffic : false) : urlParams.bnplTraffic === 'false' ? false : true,
        })
        setStatus(urlParams.status ? urlParams.status : status ? status : '')
        setAdminId(urlParams.adminId && parseInt(urlParams.adminId) > 0 ? parseInt(urlParams.adminId) : parseInt(adminId) > 0 ? adminId : 0)
        setCountry(urlParams.country ? urlParams.country : country ? country : '')
        setCpaType(urlParams.cpaType ? urlParams.cpaType : cpaType ? cpaType : '')
        setHtmlPostbacks(urlParams.htmlPostbacks ? urlParams.htmlPostbacks : htmlPostbacks ? htmlPostbacks : false)
        setDisplayRates(urlParams.displayRates ? urlParams.displayRates : displayRates ? displayRates : false)
        setMobileCampaign(urlParams.mobileCampaign ? urlParams.mobileCampaign : mobileCampaign ? mobileCampaign : false)
        setTrackingPlatform(urlParams.trackingPlatform ? urlParams.trackingPlatform : trackingPlatform ? trackingPlatform : '')
        setCurrency(urlParams.currency ? urlParams.currency : currency ? currency : '')
        setFlagId(urlParams.flagId ? urlParams.flagId : flagId ? flagId : '')
        setCategory({
            categoryId: urlParams.categoryId && parseInt(urlParams.categoryId) > 0 ? parseInt(urlParams.categoryId) : parseInt(category.categoryId) > 0 ? category.categoryId : 0,
            subCategoryId: urlParams.subCategoryId && parseInt(urlParams.subCategoryId) > 0 ? parseInt(urlParams.subCategoryId) : parseInt(category.subCategoryId) > 0 ? category.subCategoryId : 0,
        })
        setTrackingType(urlParams.setTrackingType ? urlParams.setTrackingType : setTrackingType ? setTrackingType : '')
        setCampaignType(urlParams.campaignType ? urlParams.campaignType : campaignType ? campaignType : '')
        setPaymentDelay(urlParams.paymentDelay ? urlParams.paymentDelay : paymentDelay ? paymentDelay : '')
        setPrepop(urlParams.prepop ? urlParams.prepop : prepop ? prepop : '')
        setCoupon(urlParams.coupon ? urlParams.coupon : coupon ? coupon : '')
        setDeeplink(urlParams.deeplink ? urlParams.deeplink : deeplink ? deeplink : '')

        getResults(urlParams.searchTerm ? encodeURIComponent(urlParams.searchTerm) : '')
    }, [location])

    const getResults = (searchTerm) => {
        if (location.search.length > 0) {
            // Only if there are query params

            let url = buildUrl(`campaigns/search?searchTerm=${encodeURIComponent(searchTerm)}`)

            callAPI(url, 'GET')
                .then((result) => {
                    if (result['success'] === true) {
                        setSearchResults(result.search_results)
                        setDataLoaded(true)
                    } else if (result['success'] === false) {
                        showSystemMessage('error', result.errors.message)
                        setDataLoaded(true)
                    }
                })
                .catch((error) => {
                    showSystemMessage('error', 'An error occurred while getting custom flags')
                    // setDataLoaded(true)
                })
        } else {
            setDataLoaded(true)
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        let url = buildUrl(`/campaigns/search?searchTerm=${encodeURIComponent(e.target.search_term.value)}`)
        history.push(url)
    }

    let results

    if (dataLoaded === false) {
        results = <Loading />
    } else {
        results = <SearchResults searchResults={searchResults} />
    }

    return (
        <div>
            <div className="page-header d-flex align-items-center">
                <h1 className="mb-h1">Campaign Search</h1>
            </div>
            <div className="card">
                <div className="card-body p-0">
                    <form className="form-group mb-0" onSubmit={handleSubmit}>
                        <div className="d-flex p-3 align-items-center justify-content-center" style={{ backgroundColor: '#f4f4f4' }}>
                            <input className="form-control mr-2 w-75" type="text" name="search_term" placeholder="Keyword..." autoComplete="off" defaultValue={urlParams.searchTerm ? urlParams.searchTerm : ''} />
                            <button type="submit" className="btn btn-primary mr-2">
                                Search
                            </button>
                            <button type="button" className="btn btn-link no-shadow" onClick={() => setOpen(!open)} aria-controls="example-collapse-text" aria-expanded={open}>
                                Search Options
                            </button>
                        </div>
                        <Collapse in={open}>
                            {/* Must wrap the component in <div> to make Collapse work*/}
                            <div>                                
                                <SearchOptions traffic={traffic} setTraffic={setTraffic} status={status} setStatus={setStatus} adminId={adminId} setAdminId={setAdminId} country={country} setCountry={setCountry} cpaType={cpaType} setCpaType={setCpaType} htmlPostbacks={htmlPostbacks} setHtmlPostbacks={setHtmlPostbacks} displayRates={displayRates} setDisplayRates={setDisplayRates} mobileCampaign={mobileCampaign} setMobileCampaign={setMobileCampaign} trackingPlatform={trackingPlatform} setTrackingPlatform={setTrackingPlatform} currency={currency} setCurrency={setCurrency} flagId={flagId} setFlagId={setFlagId} category={category} setCategory={setCategory} trackingType={trackingType} setTrackingType={setTrackingType} campaignType={campaignType} setCampaignType={setCampaignType} paymentDelay={paymentDelay} setPaymentDelay={setPaymentDelay} showSystemMessage={showSystemMessage} safeSearchEnabled={safeSearchEnabled} setSafeSearchEnabled={setSafeSearchEnabled} safeSearchCertified={safeSearchCertified} setSafeSearchCertified={setSafeSearchCertified} prepop={prepop} setPrepop={setPrepop} coupon={coupon} setCoupon={setCoupon} deeplink={deeplink} setDeeplink={setDeeplink} />
                            </div>
                        </Collapse>
                    </form>
                    {results}
                </div>
            </div>
        </div>
    )
}

export default SearchCampaigns
